import { defineFetch } from 'resift';

interface SearchFilterQueryParamsRequest {
  filter: any;
  name: string; // {role name} members
}

const makeCreateSearchFilterQueryParams = defineFetch({
  displayName: 'Create Search Filter Query Params',
  make: () => ({
    request: (data: SearchFilterQueryParamsRequest) => async ({ http }) => {
      const response = await http({
        method: 'POST',
        route: '/util/get-search-filter-query-params',
        data,
      });

      return response.filter; // a base64 encoded string in the filter propert
    },
  }),
});

const createSearchFilterQueryParams = makeCreateSearchFilterQueryParams();

export default createSearchFilterQueryParams;
